import React, { useState } from 'react';
import RoomStage from '../../../../../components/ui/RoomStage/RoomStage';
import styles from '../Flat.module.scss';
import { texts } from '../../../../../constants/texts';
import WithModalRoomStage from '../../../../../components/ui/WithModalRoomStage/WithModalRoomStage';

const FlatRoomStage = () => {
  const [visibleForm, setVisibleForm] = useState(false);
  const onClickClose = () => setVisibleForm(false);
  const onClicOpen = () => setVisibleForm(true);

  return (
    <>
      <RoomStage
        className={styles.grow}
        title={texts.flatRoomStage}
        openForm={onClicOpen}
      />
      <WithModalRoomStage
        visible={visibleForm}
        onOk={onClickClose}
        onCancel={onClickClose}
      />
    </>
  );
};

export default FlatRoomStage;
